var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("ac-data-table", {
        attrs: {
          headers: _vm.headerVisible(_vm.headers),
          items: _vm.headerFilter(_vm.items),
          "item-class": _vm.row_class,
          "hide-default-footer": "",
          "disable-pagination": "",
          "sort-by": "name",
          "item-key": "uid",
          "fixed-header": "",
          height: _vm.winsize.height - 145,
          search: _vm.search,
          "can-select": (item) => !_vm.row_readonly(item),
          "can-delete": (item) => !_vm.row_readonly(item),
          "remove-bulk": _vm.bulkRemove,
          "bulk-mode": _vm.bulkMode,
          title: "Tutorials",
        },
        on: {
          "update:search": function ($event) {
            _vm.search = $event
          },
          "update:bulkMode": function ($event) {
            _vm.bulkMode = $event
          },
          "update:bulk-mode": function ($event) {
            _vm.bulkMode = $event
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { color: "primary" },
                      on: { click: _vm.row_create },
                    },
                    [_vm._v(" New Tutorial ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { color: "accent" },
                      on: { click: _vm.show_preview },
                    },
                    [_vm._v(" Preview JSON ")]
                  ),
                ]
              },
              proxy: true,
            },
            _vm._l(_vm.headers, function (header, index) {
              return {
                key: `header.${header.value}`,
                fn: function () {
                  return [
                    header.filters
                      ? _c(
                          "span",
                          { key: index + header },
                          [
                            _vm._v(" " + _vm._s(header.text) + " "),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "offset-y": "",
                                  "close-on-content-click": false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                { attrs: { icon: "" } },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: header.filters.length
                                                      ? "primary"
                                                      : "",
                                                  },
                                                },
                                                [_vm._v(" mdi-filter-variant ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "background-color": "white",
                                      width: "280px",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list",
                                      [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c("v-autocomplete", {
                                              staticClass: "mt-3",
                                              attrs: {
                                                items:
                                                  _vm.headerFilterValues(
                                                    header
                                                  ),
                                                label: "Select filters",
                                                chips: "",
                                                "small-chips": "",
                                                "auto-select-first": "",
                                                multiple: "",
                                                dense: "",
                                                color: "light-blue lighten-3",
                                                "append-icon": "mdi-filter",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "selection",
                                                    fn: function (data) {
                                                      return [
                                                        _c(
                                                          "v-chip",
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "ma-1",
                                                              attrs: {
                                                                "input-value":
                                                                  data.selected,
                                                                close: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  data.select,
                                                                "click:close":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.headerFilterRemove(
                                                                      header,
                                                                      data.item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-chip",
                                                            data.attrs,
                                                            false
                                                          ),
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  data.item
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "item",
                                                    fn: function (data) {
                                                      return [
                                                        _c(
                                                          "v-list-item-content",
                                                          {
                                                            domProps: {
                                                              textContent:
                                                                _vm._s(
                                                                  data.item
                                                                ),
                                                            },
                                                          }
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: header.filters,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    header,
                                                    "filters",
                                                    $$v
                                                  )
                                                },
                                                expression: "header.filters",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _c("span", { key: header + index }, [
                          _vm._v(" " + _vm._s(header.text) + " "),
                        ]),
                  ]
                },
                proxy: true,
              }
            }),
            {
              key: "item.v2",
              fn: function ({ item }) {
                return [
                  _c("div", { attrs: { align: "center" } }, [
                    _vm._v(_vm._s(item.v2 ? "ON" : "OFF")),
                  ]),
                ]
              },
            },
            {
              key: "item.master",
              fn: function ({ item }) {
                return [
                  _c("div", { attrs: { align: "center" } }, [
                    _vm._v(_vm._s(item.master ? "ON" : "OFF")),
                  ]),
                ]
              },
            },
            {
              key: "item.showNext",
              fn: function ({ item }) {
                return [_vm._v(" " + _vm._s(_vm.getShowNext(item)) + " ")]
              },
            },
            {
              key: "item.enabled",
              fn: function ({ item }) {
                return [
                  _c("div", { attrs: { align: "center" } }, [
                    _vm._v(_vm._s(item.enabled ? "ON" : "OFF")),
                  ]),
                ]
              },
            },
            {
              key: "item.actions",
              fn: function ({ item }) {
                return [
                  _vm.row_readonly(item)
                    ? _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "", color: "green" },
                          on: {
                            click: function ($event) {
                              return _vm.row_view(item)
                            },
                          },
                        },
                        [_vm._v(" mdi-eye ")]
                      )
                    : item.locked
                    ? _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "", color: "orange" },
                          on: {
                            click: function ($event) {
                              return _vm.row_update(item)
                            },
                          },
                        },
                        [_vm._v(" mdi-pencil ")]
                      )
                    : _c(
                        "v-icon",
                        {
                          staticClass: "mr-2",
                          attrs: { small: "", color: "green" },
                          on: {
                            click: function ($event) {
                              return _vm.row_update(item)
                            },
                          },
                        },
                        [_vm._v(" mdi-pencil ")]
                      ),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "", color: "teal lighten-1" },
                      on: {
                        click: function ($event) {
                          return _vm.row_copy(item)
                        },
                      },
                    },
                    [_vm._v(" mdi-content-copy ")]
                  ),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        disabled: item.global || item.shared,
                        small: "",
                        color: "blue",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.row_export(item)
                        },
                      },
                    },
                    [_vm._v("mdi-briefcase-upload")]
                  ),
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        disabled: _vm.row_readonly(item),
                        small: "",
                        color: "red",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.row_remove(item)
                        },
                      },
                    },
                    [_vm._v(" mdi-delete ")]
                  ),
                ]
              },
            },
            {
              key: "no-results",
              fn: function () {
                return [
                  _c(
                    "v-alert",
                    { attrs: { value: true, color: "blue-grey", dense: "" } },
                    [
                      _vm._v(
                        ' Your search for "' +
                          _vm._s(_vm.search) +
                          '" found no results. '
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c("r-tutorial-dialog", { ref: "dialog" }),
      _c("r-dialog-preview-collection", { ref: "previewCollection" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }